
function escapeWishlistHtml(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
}

/**
 * @fileoverview The file mananage dT Theme cookie based wishList 
 * dT_General.js, axios, vue libs are dependencies. 
 * @package
 */
class dT_WhistList {

  constructor() {
    this.wishListData = [];

    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
  }

  setListLocalStorageKey(LOCAL_STORAGE_WISHLIST_KEY, LOCAL_STORAGE_DELIMITER) {
    this.LOCAL_STORAGE_WISHLIST_KEY = LOCAL_STORAGE_WISHLIST_KEY;
    this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
  }

  setupGrid(listType) {
    var wishlist = this.getWishlist();

    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = '/products/' + handle + '?view=json';

      var getProductsList = this.getProductResponse(productTileTemplateUrl);

      return getProductsList;
    }.bind(this));


    return Promise.all(requests).then(function (responses) {
      return responses.flatMap(record => {
        let product;
        try { product = JSON.parse(record); } catch (_) { return []; }
        if (!product || !product.product_handle) return [];
        return [{
          ...product,
          available: String(product.available),
          price_varies: String(product.price_varies),
          quantity: '1',
          product_url: '/products/' + encodeURIComponent(product.product_handle)
        }];
      });

    }).then(function (data) {

      this.wishListData = data;

      return data;

    }.bind(this));

  }

  getWishListRecords() {
    return this.wishListData;
  }

  // getCompareListRecords()
  // {
  //     return this.wishListData;
  // }

  getProductResponse(url) {

    var responseResult = fetch(url)
      .then((response) => {
        //console.log(response); 
        return response.text();
      })
      .then((data) => {
        //console.log(data); 
        return data.replace(/^\s*[\r\n]/gm, '');
      });

    return responseResult;

  }

  getTotalCount() {
    return this.getWishlist().length;
  }

  getWishlist() {
    var wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER).filter(handle => /^[a-z0-9-]+$/.test(handle));
    return [];
  }

  setWishlist(array) {
    var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    var wishlist = this.getWishlist();
    var indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  removeWhishlist(handle) {
    var wishlist = this.getWishlist();

    wishlist = this.remove(wishlist, handle);

    return this.setWishlist(wishlist);
  }

  resetWishlist() {
    return this.setWishlist([]);
  }

  isAddedIntoList(handle) {
    var wishlist = this.getWishlist();

    return wishlist.includes(handle);
  }

  remove(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      what = a[--L];
      while ((ax = arr.indexOf(what)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  };
}


async function getDTProduct(url) {


  try {
    let res = await fetch(url);

    return res.text().then(function (text) {
      return text;
    });


  } catch (error) {
    console.error(error);
  }
}

class dTXWhishList extends HTMLElement {
  constructor() {
    super();

    this.dTWhistList = new dT_WhistList();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);


    this.addWishList = this.querySelector('.add-wishlist');

    this.productHandle = this.addWishList.getAttribute('data-product_handle');
    this.addWishList.addEventListener('click', this.debouncedOnSubmit.bind(this));

    this.initLoad();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      window.location = "/pages/wishlist";
    } else {
      this.addWishList.classList.add("adding");

      this.dTWhistList.updateWishlist(this.productHandle);

      setTimeout(this.postAdd.bind(this), 100);
    }
  }

  postAdd() {
    var dtxwishCounts = document.querySelectorAll(".dtxc-wishlist-count");
    dtxwishCounts.forEach(function (dtxwishCount) {
      dtxwishCount.setAttribute('count', this.dTWhistList.getTotalCount());
    }.bind(this));

    var mobileDtxwishCounts = document.querySelectorAll(".mobile-dtxc-wishlist-count");
    mobileDtxwishCounts.forEach(function (mobileDtxwishCount) {
      mobileDtxwishCount.setAttribute('count', this.dTWhistList.getTotalCount());
    }.bind(this));

    this.addWishList.classList.remove("adding");
    this.addWishList.classList.add("added");
  }

  initLoad() {
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      this.addWishList.classList.add("added");
    }
  }
}

customElements.define('dtx-wishlist', dTXWhishList);




class dTXWhishListGrid extends HTMLElement {
  constructor() {
    super();

    this.gridTemplate = this.querySelector('.grid_template');
    this.gridContainer = this.querySelector(".wishlist-grid-container");
    this.dtxNoRecord = this.querySelector(".dtx-grid-empty");

    this.grid_type = this.getAttribute('grid_type');
    //this.initLoad();
  }

  initLoad() {

    var dTWhistList = new dT_WhistList();
    // if ("compareList" == this.grid_type) {
    //   dTWhistList.setListLocalStorageKey('dt-compare-list', ',');
    // }


    dTWhistList.setupGrid().then(function (data) {
      this.generateGrid(data);

      return data;
    }.bind(this));

  }

  generateGrid(a_records) {
    // Keep the template, remove other content if any (though usually empty on load)
    // Actually, sticking to the existing pattern: 
    // The template is inside the container in my HTML structure. 
    // So I should simple append new items.

    if (typeof a_records[0] !== 'undefined' && typeof a_records[0].product_handle !== 'undefined') {
      if (a_records.length > 0) {

        // Hide the template
        this.gridTemplate.style.display = 'none';

        a_records.forEach(function (record) {
          // Create a new div for the card
          var div = document.createElement('div');
          div.className = 'wishlist-card';
          div.id = 'row_' + record.id;
          div.innerHTML = this.buildCard(record);
          this.gridContainer.appendChild(div);
        }.bind(this));

        this.dtxNoRecord.style.display = 'none';
        this.gridContainer.style.display = 'grid'; // Ensure grid is visible

      }
    } else {
      this.gridContainer.style.display = 'none';
      this.dtxNoRecord.style.display = 'block';
    }

  }

  buildCard(record) {
    // Get the inner HTML of the template container
    var templateData = this.gridTemplate.innerHTML;

    templateData = templateData.replace(/{item.product_handle}/gi, () => escapeWishlistHtml(record.product_handle));
    templateData = templateData.replace(/{item.product_url}/gi, () => escapeWishlistHtml(record.product_url));
    templateData = templateData.replace(/{item.product_image}/gi, () => escapeWishlistHtml(record.product_image));
    templateData = templateData.replace(/{item.product_title}/gi, () => escapeWishlistHtml(record.product_title));
    templateData = templateData.replace(/{item.money_price}/gi, () => escapeWishlistHtml(record.money_price));
    templateData = templateData.replace(/{item.variant_id}/gi, () => escapeWishlistHtml(record.variant_id));
    templateData = templateData.replace(/{item.product_vendor}/gi, () => escapeWishlistHtml(record.vendor));
    templateData = templateData.replace(/{item.product_type}/gi, () => escapeWishlistHtml(record.type));
    templateData = templateData.replace(/{item.product_sku}/gi, () => escapeWishlistHtml(record.sku));
    templateData = templateData.replace(/{item.product_description}/gi, () => escapeWishlistHtml(record.description));
    if (record.available == 'true') {
      templateData = templateData.replace(/{item.available}/gi, 'In Stock');
    }
    else {
      templateData = templateData.replace(/{item.available}/gi, 'Sold Out');
    }
    return templateData;

  }

  connectedCallback() {
    // console.log('Custom square element added to page.');
    this.initLoad();

  }


}

customElements.define('dtx-wishlist-grid', dTXWhishListGrid);



class dTXRemoveWishItem extends HTMLElement {

  constructor() {
    super();

    this.removeItem = this.querySelector('.remove-item');


    this.debouncedOnSubmit = debounce((event) => {
      this.removeListItem(event);
    }, 500);


    this.grid_type = this.getAttribute('grid_type');

    this.productHandle = this.removeItem.getAttribute('data-product_handle');

    this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));

  }

  removeListItem(event) {
    event.preventDefault();

    var dTWishList = new dT_WhistList();
    dTWishList.removeWhishlist(this.productHandle);

    // Remove the card directly from DOM
    const card = this.closest('.wishlist-card');
    if (card) {
      card.remove();
    }

    // Update the total count globally
    var totalCount = dTWishList.getTotalCount();

    var dtxwishCounts = document.querySelectorAll(".dtxc-wishlist-count");
    dtxwishCounts.forEach(function (dtxwishCount) {
      dtxwishCount.setAttribute('count', totalCount);
    });

    var mobileDtxwishCounts = document.querySelectorAll(".mobile-dtxc-wishlist-count");
    mobileDtxwishCounts.forEach(function (mobileDtxwishCount) {
      mobileDtxwishCount.setAttribute('count', totalCount);
    });

    // Check if wishlist is empty and update UI
    if (totalCount === 0) {
      var grid = document.querySelector("dtx-wishlist-grid");
      if (grid) {
        var container = grid.querySelector(".wishlist-grid-container");
        var emptyMsg = grid.querySelector(".dtx-grid-empty");
        if (container) {
          container.style.display = 'none';
        }
        if (emptyMsg) {
          emptyMsg.style.display = 'block';
        }
      }
    }
  }

}

customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);



class dTXWishCount extends HTMLElement {

  static get observedAttributes() {
    return ['count'];
  }

  constructor() {
    super();

    this.gridCountBubble = this.querySelector('.grid-count-bubble');

    this.grid_type = this.getAttribute('grid_type');

    this.initLoad();
  }

  initLoad() {

    var dTWishList = new dT_WhistList();
    // if ("compareList" == this.grid_type) {
    //   dTWishList.setListLocalStorageKey('dt-compare-list', ',');
    // }

    var totalCount = dTWishList.getTotalCount();

    //this.setAttribute('count', totalCount);  

    this.gridCountBubble.querySelector("span").innerHTML = totalCount;
    const loadCount = this.gridCountBubble.querySelector("span").innerHTML;
    if (parseInt(loadCount) == 0) {
      this.classList.add('count-zero');
      this.classList.remove('count-exist');
    } else {
      this.classList.remove('count-zero');
      this.classList.add('count-exist');
    }

  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.initLoad();
  }


}

customElements.define('dtx-wish-count', dTXWishCount);


class MobiledTXWishCount extends HTMLElement {

  static get observedAttributes() {
    return ['count'];
  }

  constructor() {
    super();

    this.gridCountBubble = this.querySelector('.grid-count-bubble');

    this.grid_type = this.getAttribute('grid_type');

    this.initLoad();
  }

  initLoad() {

    var dTWishList = new dT_WhistList();
    var totalCount = dTWishList.getTotalCount();

    //this.setAttribute('count', totalCount);  

    this.gridCountBubble.querySelector("span").innerHTML = totalCount;


  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.initLoad();
  }


}

customElements.define('mobile-dtx-wish-count', MobiledTXWishCount);

function makeTimer() {

  $('.product-deal-count').each(function () {

    var endTime = new Date($(this).attr('data-end-time'));
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;

    if (timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400);
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }

      $(this).find(".days").html(days + "<span>Days</span>");
      $(this).find(".hours").html(hours + "<span>Hrs</span>");
      $(this).find(".minutes").html(minutes + "<span>Mins</span>");
      $(this).find(".seconds").html(seconds + "<span>Secs</span>");

    } else {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }

  });

}

setInterval(function () { makeTimer(); }, 1000);
